import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface Type {
    comparison: any
    setComparison: (value: any) => void
}

const initialState: Type = {
    comparison: [],
    setComparison: () => {},
}

const comparisonStore = create<Type>(
    persist(
        (set) => ({
            ...initialState,
            setComparison: (value: any) => set({ comparison: value }),
        }),
        {
            name: 'comparison-store',
        },
    ) as any,
)

export default comparisonStore
